module.exports = __webpack_public_path__ + "assets/img/travel-day38.e8f13c51.png";